import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'

export const Root = styled('div')`
  background-color: ${props => props.theme.palette.blue[35]};
  min-height: 206px;
  margin: 93px 0 0;
  width: 100%;
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.white};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: 300;
  line-height: 26px;
  text-align: center;
  margin: 0;
`

export const Subtitle = styled('h3')`
  color: ${props => props.theme.palette.brand.white};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 18px;
  font-weight: 300;
  line-height: 21px;
  text-align: center;
  margin: 0;
`
export const MailLink = styled('a')`
  color: ${props => props.theme.palette.brand.white};
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  text-align: center;
  cursor: pointer;
  margin: 0;

  &:hover {
    text-decoration: underline;
  }
`
